module.exports = __webpack_public_path__ + "img/otp_micoapp.427edef3.jpg";